import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import OtpModal from '../Cart/OtpModal';
import { useHistory } from 'react-router-dom';
import { useDispatch, connect, useSelector } from 'react-redux';
import { signup, sendOtp, verifyOtp } from '../../Redux/actions/customer';
import { toast } from 'react-toastify';
import Header from '../../Components/Header';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { checkPhone, MOBILE_STARS, NUMBERS_LIMIT, PHONE_CODE } from '../../lib';


function SignUp(props: any) {
    const { signup, sendOtp, verifyOtp } = props;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phonenumber, setPhonenumber] = useState("");
    const [gender, setGender] = useState("male")
    const [date, setDate] = useState("");
    const [show, setShow] = useState(false);
    const history = useHistory();
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [phonError, setphonError] = useState(false)
    const [emailError, setEmailError] = useState(false);
    const [emailDisable, setEmailDisable] = useState(false);
    const [disable, setDisable] = useState(true);
    const [passDisable, setPassDisable] = useState(true);
    const [otp, setOtp] = useState('');
    const [disableVerifyBtn, setDisableVerifyBtn] = useState(true);
    const [dateDisable, setDateDisable] = useState(true);

    const [showPassword, setShowPassword] = useState(false);
    const [confirmshowPassword, setConfirmShowPassword] = useState(false);
    const [passwordError, setPasswordError] = useState(false)
    const [confirmPasswordError, setConfirmPasswordError] = useState(false)
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const lang = useCurrentLocale();
    const { t } = useTranslation();

    useEffect(() => {
        if (isLogged) {
            history.push(`/${lang}/`);
        }
    },[])

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleshowTogglePassword = () => {
        setConfirmShowPassword(!confirmshowPassword);
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleFirstName = (e: any) => {
        const input = e.target.value;
        const regex = /^[a-zA-Z]*$/;

        if (regex.test(input)) {
            setFirstname(input);
        }
    }

    const handleLastName = (e: any) => {
        const input = e.target.value;
        const regex = /^[a-zA-Z]*$/;

        if (regex.test(input)) {
            setLastname(input);
        }
    }

    const handlePhone = (e: any) => {
        const { value } = e.target;
        if (value.length <= NUMBERS_LIMIT) {
            setPhonenumber(value);
        }
        if (!checkPhone(value)) return;
        if (value.length == NUMBERS_LIMIT) {
            setphonError(false);
        }
        if (value.length < NUMBERS_LIMIT) {
            setphonError(true);
        }
    };

    const handleEmailChange = (e: any) => {
        const input = e.target.value;
        setEmail(e.target.value);

        const emailRegex = /^\S+@\S+\.\S+$/;
        setEmailError(!emailRegex.test(input));
        setEmailDisable(emailRegex.test(input))
    };

    const handlePassword2 = (e: any) => {
        setPassword(e.target.value)
        if (e.target.value.length < 8) {
            setPasswordError(true);
        }
        else {
            setPasswordError(false)
        }
    }
    const handlePassword = (e: any) => {
        setPassword(e.target.value)
        if (e.target.value.length < 8) {
            setPasswordError(true)
        }
        else {
            setPasswordError(false)
        }
        if (e.target.value.length >= 8 && e.target.value == confirmPassword) {
           
        }
        
        setPassDisable(false)
    }
    const handleConfirmPassword = (e: any) => {
        setConfirmPassword(e.target.value)
        if (password != e.target.value) {
            setConfirmPasswordError(true)
        }
        else {
            setConfirmPasswordError(false)
        }
        
        setPassDisable(false)

    }


    const handleVerifyOtp = () => {
        const data: any = {
            first_name: firstname,
            last_name: lastname,
            login_name: firstname + " " + lastname,
            email_address: email,
            login_password: password,
            phone_number: `${PHONE_CODE}-` + phonenumber,
            otp: otp,
            is_active: 1,
            setDisableVerifyBtn
        }
        verifyOtp(data, history, setShow)

    }

    const handleSignUp = () => {
        sendOtp({
            phone_number: `${PHONE_CODE}-` + phonenumber
        }, history)
        setShow(true);
    }
    const handleEnterPress = (e: any) => {
        if (e.key == "Enter" && firstname && lastname && checkPhone(phonenumber) && emailDisable && !passwordError && !confirmPasswordError) {
            sendOtp({
                phone_number: `${PHONE_CODE}-` + phonenumber
            }, history)
            setShow(true);

        }
        else if (e.key == "Enter") {
            toast.error(t("FILL_ALL_FIELDS"))
        }
    }

    useEffect(() => {
        if (firstname && lastname && checkPhone(phonenumber) && emailDisable && !passwordError && !confirmPasswordError && password == confirmPassword) {
            setDisable(false)
        } else {
            setDisable(true)
        }
    }, [firstname, lastname, phonenumber, email, password, confirmPassword])
    const handleDate = (e: any) => {
        const selectedDate = e.target.value;
        const currentDate = new Date().toISOString().split('T')[0];
        if (selectedDate <= currentDate) {
            setDate(selectedDate);
            setDateDisable(false)
        } else {
            toast.error(t("FUTURE_DATE_ERROR"))
            setDate("");
            setDateDisable(true)
        }
    }
    useEffect(() => {
        if (otp.length >= 4) {
            handleVerifyOtp()
        }
    }, [otp])

    return (
        <>
            <Header />
            <div className='container-xxl category-container-custom mt-120 mb-md-100'>

                <div className="row">
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div className="login-guest mb-4">
                            <div className="row">
                               
                                <div className="col-md-8 offset-md-2">
                                    <div className='welcome-login font-normal '>
                                        <h3 className='mb-0'>{t("SIGNUP")} !</h3>
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                <TextField onKeyPress={handleEnterPress} value={firstname} onChange={handleFirstName} className='field-style color-white' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("FIRST_NAME")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <TextField onKeyPress={handleEnterPress} value={lastname} onChange={handleLastName} className='field-style color-white' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("LAST_NAME")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 mt-3">
                                            <TextField
                                                type='text'
                                                onKeyPress={handleEnterPress}
                                                value={phonenumber} onChange={handlePhone}
                                                className='field-style color-white' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("PHONE_NUMBER")} ({MOBILE_STARS})</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error"
                                                InputProps={{
                                                    startAdornment: <InputAdornment className='font-normal number-field' position="start">{PHONE_CODE}</InputAdornment>,
                                                }}
                                                helperText={phonError ? t("PHONE_ERROR",{limit:NUMBERS_LIMIT}) : ""}
                                            />
                                        </div>
                                        <div className="col-md-12 mt-3">
                                            <TextField
                                                onKeyPress={handleEnterPress}
                                                value={email}
                                                onChange={handleEmailChange}
                                                helperText={emailError ? 'Invalid email format' : ''}
                                                className='field-style color-white' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("EMAIL")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                        </div>


                                        

                                        <div className="col-md-12 mt-3">
                                            <TextField type='date'
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                onChange={handleDate}
                                                value={date}
                                                className='field-style'
                                                label={<div className='font-normal d-flex gap-1'><p>{t("DATE_OF_BIRTH")}</p><p className='color-theme h4'>*</p></div>}
                                                variant="filled"
                                                name="dateofbirth" id="dateofbirth"
                                                color="error" />
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                <div className='position-relative'>
                                                    <TextField
                                                        value={password}
                                                        onChange={handlePassword}
                                                        onKeyPress={handleEnterPress}
                                                        helperText={passwordError ? 'Password Length must 8 character Long' : ''}
                                                        name="input2"
                                                        className='field-style text-error-login' id="filled-basic" autoComplete="new-password" type={showPassword ? 'text' : 'password'} label={<div className='font-normal d-flex gap-1'><p>Password</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                                    <Button onClick={handleTogglePassword} className='eye-btn' color="error"><i className={showPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className='position-relative'>
                                                    <TextField
                                                        value={confirmPassword}
                                                        onChange={handleConfirmPassword}
                                                        onKeyPress={handleEnterPress}
                                                        helperText={confirmPasswordError ? 'Passwords do not match' : ''}
                                                        name="input2"
                                                        className='field-style text-error-confirm' id="filled-basic" autoComplete="new-password" type={confirmshowPassword ? 'text' : 'password'} label={<div className='font-normal d-flex gap-1'><p>Confirm Password</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                                    <Button onClick={handleshowTogglePassword} className='eye-btn' color="error"><i className={confirmshowPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                                                </div>
                                            </div>
                                        </div>
                                        <FormControl>
                                            <h6 className='gender-select'>{t("GENDER")} <span className='color-theme h4'>*</span></h6>

                                            <RadioGroup
                                                value={gender}
                                                onKeyPress={handleEnterPress}
                                                onChange={(e) => setGender(e.target.value)}
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel className='color-white' value="Male" control={<Radio className='color-theme' />} label={t("MALE")} />
                                                <FormControlLabel className='color-white' value="Female" control={<Radio className='color-theme' />} label={t("FEMALE")} />
                                                <FormControlLabel className='color-white' value="Others" control={<Radio className='color-theme' />} label={t("OTHERS")} />
                                            </RadioGroup>
                                        </FormControl>
                                        <div>
                                            <Button disabled={disable || passDisable || dateDisable} onClick={handleSignUp}
                                                className={`${disable || passDisable || dateDisable ? "disable-btn " : "able-btn"} m-auto d-flex mt-4 coupon-otp-btn w-100 font-medium`} variant="contained" color="error">Sign up</Button>

                                            <Modal className='payment-modal' show={show} onHide={handleClose} centered>
                                                <div className='modal-design'>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                                <Modal.Header className='justify-content-center' closeButton>
                                                    <Modal.Title className='font-bold h4'>{t("VALIDATE_OTP")}</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body className='w-100 delivery-order'>
                                                    <OtpModal otp={otp} setOtp={setOtp} phone_number={`${PHONE_CODE}-` + phonenumber} />
                                                    <div className='d-flex justify-content-between gap-10'>
                                                        <Button disabled={disableVerifyBtn} onClick={handleVerifyOtp}
                                                            className={`w-50 m-auto d-flex mt-4 ${disableVerifyBtn ? "disable-btn" : "able-btn"} `} variant="contained" color="error">{t("VERIFY")}</Button>
                                                    </div>
                                                </Modal.Body>

                                            </Modal>
                                        </div>

                                        <div className='d-flex align-items-center gap-10'>
                                            <h6 className='font-normal color-white mt-3 mb-0'>{t("ALREADY_GOT_AN_ACCOUNT")}</h6>
                                            <Link className='mt-3 color-theme' color="error" to={`/${lang}/login`}>{t("LOGIN")}</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                </div>
            </div>
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        signup: function (data: any, history?: any) {
            dispatch(signup(data, history));
        },
        sendOtp: function (data: any) {
            dispatch(sendOtp(data))
        },
        verifyOtp: function (data: any, history?: any, setState?: any) {
            dispatch(verifyOtp(data, history, setState))
        }
    }
}
export default connect(null, mapDispatchToProps)(SignUp);
